import { render, staticRenderFns } from "./CommentsAppendix.vue?vue&type=template&id=d688cac8&scoped=true&"
import script from "./CommentsAppendix.vue?vue&type=script&lang=js&"
export * from "./CommentsAppendix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d688cac8",
  null
  
)

export default component.exports